export default "__VITE_ASSET__0bd97a78__"